

const PlatformEnum = {
  Stripe: "stripe",
  Paypal: "paypal",
  Dawipay: "dawipay",
}

export default PlatformEnum;
